// US-UI-MOBILE-PREVIEW -- shared signal for the mobile preview toggle.
//
// A module-level Solid signal so any component in the app can read /
// write the toggle state. The App.tsx root applies the framing
// styles when the toggle is on (centred 390 × 844 frame, muted
// background outside, with `data-viewport-mode="mobile"` on the
// frame so width-based CSS responds to the framed dimensions
// instead of the outer Tauri window).
//
// The toggle is one-way only: when on, app renders inside the
// frame; when off, it goes back to full-width desktop. There is no
// inverse toggle on real mobile devices -- Settings hides the
// toggle when the viewport is already narrow.

import { createSignal } from 'solid-js';

const [mobilePreviewEnabled, setMobilePreviewEnabled] = createSignal(false);

export { mobilePreviewEnabled, setMobilePreviewEnabled };

/** Mobile-breakpoint check: is the viewport wider than the threshold?
 *  Returns false on SSR or when window isn't available. */
export function isViewportWideEnoughForMobilePreview(): boolean {
  if (typeof window === 'undefined') return false;
  return window.innerWidth > 600;
}
